// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vz_a bhi_b bhi_wb"};